/*
    UserAgent features detector
 */

export const UA = {
    isMobileDevice: /Mobi/i.test(window.navigator.userAgent),
    isFacebook: /(FB4A|FBAN)/i.test(window.navigator.userAgent),
    isFacebookMessenger: /(FB_IAB\/Orca|FB_IAB\/Messenger|FBAN\/Messenger)/i.test(window.navigator.userAgent),
    isIOS: /(iPhone|iPad)/i.test(window.navigator.userAgent),
    isAndroid: /(Android)/i.test(window.navigator.userAgent),
    isIframe: window !== window.parent,
};
